import { css } from 'linaria';

export const bannerNameWrapper = css`
  display: flex;
  align-items: center;
  margin-right: 8px;
  column-gap: 8px;

  @media (--to-desktop) {
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

export const bannerName = css`
  && {
    @media (--from-desktop) {
      white-space: nowrap;
    }

    @media (--to-desktop) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (--only-mobile) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const bannerNameChevronIcon = css`
  && {
    @media (--only-tablet) {
      width: 20px;
      height: 20px;
    }

    @media (--only-mobile) {
      display: none;
    }
  }
`;
